import type { ResolverInput, ResolverResult } from './types';

// Reads progress.has_booking_page from the parent-fetched get_setup_progress
// snapshot. True when businesses.booking_page_customized_at IS NOT NULL (set by
// the mobile BookingPageSheet.handleSave and admin useBookingPageSettings.updateConfig
// on any user-initiated save) OR when the user explicitly skipped the item.
// Seeded booking_pages rows do NOT flip this — the timestamp stays NULL
// until a real save happens. §1.7.X consolidation removed the per-resolver
// RPC fetch — see SETUP_ITEMS_CONTRACT_v1.md Rule 1.
export async function resolveBookingPageItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_booking_page) return { complete: true, reason: 'booking page customized' };
  return { complete: false, reason: 'booking page not yet customized' };
}
